export enum LibraryType {
  SavedContent = 'Saved Content',
  Form = 'Form',
}
